import { IFontFamily } from '../FontPicker/FontPicker.types.shared';
import { isFontFamily } from './fontUtils';

export function assertFontFamily(item: unknown): asserts item is IFontFamily {
    if (isFontFamily(item)) {
        return;
    }
    throw new Error('data is not a IFontFamily object.');
}
